import { CSSTransition, TransitionGroup } from 'react-transition-group';

import Notification from './Notification';
import { InsighttNotificationType } from './types';

interface NotificationsProps {
  notifications: InsighttNotificationType[];
  onRequestHide?: (notification: InsighttNotificationType) => void;
  enterTimeout?: number;
  leaveTimeout?: number;
}

const Notifications = ({
  notifications,
  onRequestHide,
  enterTimeout = 400,
  leaveTimeout = 400,
}: NotificationsProps) => {
  const handleRequestHide = (notification: InsighttNotificationType) => () => {
    if (onRequestHide) {
      onRequestHide(notification);
    }
  };

  const className = `notification-container ${notifications.length === 0 ? 'notification-container-empty' : ''}`;
  return (
    <div className={className}>
      <TransitionGroup>
        {notifications.map((notification) => {
          const key = notification.id || new Date().getTime();
          const message = String(notification.message);
          return (
            <CSSTransition
              classNames="notification"
              key={key}
              timeout={{ exit: leaveTimeout, enter: enterTimeout }}
            >
              <Notification
                key={key}
                type={notification.type}
                title={notification.title}
                link={notification?.link}
                linkMessage={notification?.linkMessage}
                message={message}
                timeOut={notification.timeOut}
                onClick={notification.onClick}
                onRequestHide={handleRequestHide(notification)}
                customClassName={notification.customClassName}
              />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </div>
  );
};

export default Notifications;
